// DEPENDENCIES
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { useFormik } from "formik";
import moment from 'moment';
// COMPONENTS
import MUIDataTable from "mui-datatables";
import { Link, useParams } from 'react-router-dom';
import { Form } from 'react-bootstrap';
// ICONS
// CUSTOM COMPONENTS
import FormBlock from '../../../../components/FormBlock';
import Section from '../../../../components/Section';
import ContentBlock from '../../../../components/ContentBlock';
import CustomBlock from '../../../../components/CustomBlock';
import ContentHeader from '../../../../components/ContentHeader';
import InputBlock from '../../../../components/InputBlock';
import TextAreBlock from '../../../../components/TextAreBlock';
import SelectBlock from '../../../../components/SelectBlock';
import CheckboxBlock from '../../../../components/CheckboxBlock';
import ModalBlock from '../../../../components/ModalBlock';
import Button from '../../../../components/Button';
// SERVICES AND HELPERS
import LeadAirCOCValidator from "../../../../../helpers/validators/LeadAirCOCValidator";
import * as jobFormService from '../../../../../services/service/jobFormService';
import * as alert from '../../../../../redux/alertSnackBarRedux';
import * as confirmModal from '../../../../../redux/confirmModalRedux';
import * as leadAirChainOfCustodyService from '../../../../../services/form/leadAirChainOfCustodyService';
import * as helper from '../../../../../helpers/helper';
import constants from '../../../../../constants/constants';

const initialState = {
    id: 0,
    leadAirDataSheetId: null,
    turnAroundTime: '',
    projectName: '',
    projectNo: '',
    reportsResultsTo: 'katelyn@airenvironmental.net',
    laboratorySamplesSubmittedTo: '',
    relenquishedBy: '',
    submittedBy: '',
    samplers: '',
    time: null,
    cocDate: '',
    cocTime: '',
    isSubmitted: false,
    leadAirDataSheet: {
        analyzedBy: '',
    }
}

const LeadAirCOCForm = (props) => {
    const iframeRef = useRef();
    const { jobFormId, edit } = useParams();
    const { showAlert, showConfirmModal, hideConfirmModal, setProcessing, history, auth } = props;
    const [confirmDeleteModalVisible, setConfirmDeleteModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [switchMode, setSwitchMode] = useState(false);
    const [leadAirChainOfCustody, setLeadAirChainOfCustody] = useState(initialState);
    const [jobForm, setJobForm] = useState({
        id: 0,
        jobFormId: 0,
        projectNumber: "",
        client: "",
        name: "Lead-Air Chain Of Custody",
        actualAssignedDate: null,
        submittedById: 0,
        jobId: 0,
        formLead: '',
        formLeadSignature: '',
        project: '',
        job: {}
    });

    const [selectedOptions, setSelectedOptions] = useState({
        turnAroundTime: null,
    })

    const [optionList, setOptionList] = useState({
        turnAroundTime:
            [
                '1 hour',

                '2 hour',

                '3 hour',

                '4 hour',

                '24 hour',

                '48 Hour',

                '72 Hour',

                '96 Hour',

                '1 Week',

                '2 Week',
            ]
    })

    useEffect(() => {
        setLoading(true);
        if (edit == 'false') {
            setSwitchMode(true);
            getReport(jobFormId);
        }
        else {
            fetchCOC();
        }
    }, []);

    const fetchCOC = () => {
        return leadAirChainOfCustodyService.getLeadAirChainOfCustodyById(jobFormId).then(res => {
            setJobForm(res);
            setIsReadOnly(res.leadAirChainOfCustody.isSubmitted);
            setLeadAirChainOfCustody({
                ...res.leadAirChainOfCustody, projectNo: res.projectNumber,
                projectName: res.client + '- ' + res.project,
                laboratorySamplesSubmittedTo: res.leadAirChainOfCustody.leadAirDataSheet.analyzedBy,
                submittedBy: res.leadAirChainOfCustody.submittedBy ? res.leadAirChainOfCustody.submittedBy : res.formLead,
                samplers: res.leadAirChainOfCustody.samplers ? res.leadAirChainOfCustody.samplers : res.formLead,
                cocDate: res.cocDate,
                relenquishedBy: res.leadAirChainOfCustody.relenquishedBy ? res.leadAirChainOfCustody.relenquishedBy : res.formLeadSignature,
                time: (res.cocTime ? res.cocTime : '00:00')
            });
            setSelectedOptions({ ...selectedOptions, turnAroundTime: helper.setToOptionModel(res.leadAirChainOfCustody.turnAroundTime, res.leadAirChainOfCustody.turnAroundTime) });
            return res;
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(() => setLoading(false));
    }

    const submitCOC = (values, setSubmitting, isSubmitted) => {
        let tempObj = _.cloneDeep(leadAirChainOfCustody.leadAirDataSheet);
        tempObj.analyzedBy = values.laboratorySamplesSubmittedTo;
        leadAirChainOfCustodyService.save({
            ...values,
            tempObj,
            reportsResultsTo: 'katelyn@airenvironmental.net',
            isSubmitted: isSubmitted,
            time: values.cocDate + ' ' + (values.cocTime ? values.cocTime : '00:00')
        }).then(res => {
            jobFormService.submitForm(jobForm.id).then(res => {
                showAlert({ message: "Success! LeadAir COC has been submitted.", variant: 'success' });
                history.push("/services/manage-job/forms/" + jobForm.jobId);
            })
            showAlert({ message: res.message, variant: 'success' });
        }).catch(err => {
            showAlert({ message: err.message, variant: 'error' });
        }).finally(() => {
            isSubmitted && setIsReadOnly(true);
            setSubmitting(false);
        })
    }

    const getReport = (id) => {
        if (id) {
            leadAirChainOfCustodyService.getReportPdf(id).then(res => {
                iframeRef.current.src = "data:application/pdf;base64," + res;
            }).catch(ex => {
            })
        }
    }

    const saveCOC = (values, setSubmitting, isSubmitted) => {
        let tempObj = _.cloneDeep(leadAirChainOfCustody.leadAirDataSheet);
        tempObj.analyzedBy = values.laboratorySamplesSubmittedTo;
        leadAirChainOfCustodyService.save({ ...values, tempObj, reportsResultsTo: 'katelyn@airenvironmental.net', isSubmitted: isSubmitted, time: values.cocDate + ' ' + (values.cocTime ? values.cocTime : '00:00') }).then(res => {
            showAlert({ message: res.message, variant: 'success' });
        }).catch(err => {
            showAlert({ message: err.message, variant: 'error' });
        }).finally(() => {
            isSubmitted && setIsReadOnly(true);
            setSubmitting(false);
        })
    }

    const columnOptions = {
        filter: true,
        sort: true,
        print: false,
        download: true
    };

    const options = {
        selectableRows: "none",
        download: true,
        print: false,

    };

    const columns = [
        {
            name: "sampleNumber",
            label: "Sample No.",
            options: columnOptions
        },
        {
            name: "date",
            label: "Date",
            options: {
                customBodyRenderLite: (dataIndex) => <p>{
                    leadAirChainOfCustody.leadAirDataSheet.leadAirDataSheetLineItems[dataIndex].dateTime ? helper.formatToUSDate(leadAirChainOfCustody.leadAirDataSheet.leadAirDataSheetLineItems[dataIndex].dateTime) : "-"
                }</p>
            }
        },
        {
            name: "sampleType",
            label: "Sample Type",
            options: {
                customBodyRenderLite: (dataIndex) => <p>Air</p>
            }
        },
        {
            name: "sampleType",
            label: "Test",
            options: {
                customBodyRenderLite: (dataIndex) => <p>Flame AA</p>
            }
        },
        {
            name: "sampleVolume",
            label: "Sample Volume"
        },
        {
            name: "notes",
            label: "Notes",
            options: {
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <Form.Control as="textarea" rows={2} value={leadAirChainOfCustody.leadAirDataSheet.leadAirDataSheetLineItems[dataIndex].cocNotes}
                            readOnly={!auth.isAdmin && isReadOnly}
                            onChange={(e) => {
                                let tempObj = _.cloneDeep(leadAirChainOfCustody.leadAirDataSheet);
                                tempObj.leadAirDataSheetLineItems[dataIndex].cocNotes = e.target.value;
                                setLeadAirChainOfCustody({ ...leadAirChainOfCustody, ...formik.values, leadAirDataSheet: tempObj });
                            }} />
                    )
                }
            }
        },
    ];


    const formik = useFormik({
        enableReinitialize: true,
        initialValues: leadAirChainOfCustody,
        validationSchema: LeadAirCOCValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            submitCOC(values, setSubmitting, true)
        }
    });

    return (
        <>
            {
                switchMode ?
                    (<iframe ref={iframeRef} style={{ height: '100%', width: '100%' }} title="description"></iframe>)
                    :
                    <FormBlock onSubmit={formik.handleSubmit}>
                        <Section fullWidth removeContainer>
                            <ContentBlock>
                                <CustomBlock className="content-container--card-style--with-shadow">
                                    <ContentHeader
                                        title="LeadAir Analysis Request and Chain of Custody Record"
                                        headerSize="md"
                                        primaryButtonText="Print Form"
                                        primaryButtonBackgroundColor="info--bg mr-0"
                                        // secondaryButtonText="Save Changes"
                                        // secondaryButtonBackgroundColor="warning--bg"
                                        primaryButtonOnClick={() => {
                                            setSwitchMode(true)
                                            getReport(jobFormId)
                                        }}
                                    />

                                    <CustomBlock>
                                        {/* HEADER SECTION */}
                                        <Section removeContainer className="pb-10">
                                            <ContentBlock>
                                                <ContentHeader
                                                    title="Header Information"
                                                    headerSize="sm"
                                                    className="fw-700 pb-10"
                                                />
                                            </ContentBlock>

                                            <ContentBlock cols={4}>
                                                <InputBlock
                                                    readOnly={!auth.isAdmin && isReadOnly}
                                                    label="Laboratory Samples Submitted To"
                                                    // value={leadAirChainOfCustody.leadAirDataSheet.analyzedBy}
                                                    {...formik.getFieldProps("laboratorySamplesSubmittedTo")}
                                                />
                                                {formik.touched.laboratorySamplesSubmittedTo && formik.errors.laboratorySamplesSubmittedTo ? (
                                                    <div className="invalid-feedback display-block">
                                                        {formik.errors.laboratorySamplesSubmittedTo}
                                                    </div>
                                                ) : null}
                                            </ContentBlock>

                                            {/* <ContentBlock cols={4}>
                                                <InputBlock
                                                    disabled={!auth.isAdmin && isReadOnly}
                                                    label="Turn Around Time"
                                                    type="date"
                                                    options={{
                                                        dateFormat: "m/d/Y"
                                                    }}
                                                    value={{ ...formik.getFieldProps("turnAroundTime") }.value && { ...formik.getFieldProps("turnAroundTime") }.value !== '0001-01-01T00:00:00' ? moment({ ...formik.getFieldProps("turnAroundTime") }.value).format("L") : ''}
                                                    onChange={(e) => {
                                                        formik.setFieldValue("turnAroundTime", moment(e[0]).format("L"))
                                                    }}
                                                />
                                                {formik.touched.turnAroundTime && formik.errors.turnAroundTime ? (
                                                    <div className="invalid-feedback display-block">
                                                        {formik.errors.turnAroundTime}
                                                    </div>
                                                ) : null}
                                            </ContentBlock> */}

                                            <ContentBlock cols={4}>
                                                <SelectBlock
                                                    isClearable
                                                    creatableSelect
                                                    label="Turn Around Time"
                                                    inputState={formik.touched.turnAroundTime && formik.errors.turnAroundTime ? "error" : ""}
                                                    errorMessage={formik.errors.turnAroundTime}
                                                    value={selectedOptions.turnAroundTime}
                                                    options={optionList.turnAroundTime.map(x => helper.setToOptionModel(x, x))}
                                                    onChange={selectedOption => {
                                                        selectedOption = selectedOption === null ? [] : selectedOption;
                                                        setSelectedOptions({ ...selectedOptions, turnAroundTime: selectedOption });
                                                        formik.setFieldValue("turnAroundTime", selectedOption.value);
                                                    }}
                                                />
                                            </ContentBlock>

                                            <ContentBlock cols={4}>
                                                <InputBlock
                                                    readOnly={!auth.isAdmin && isReadOnly}
                                                    label="Submitted By"
                                                    {...formik.getFieldProps("submittedBy")}
                                                />
                                                {formik.touched.submittedBy && formik.errors.submittedBy ? (
                                                    <div className="invalid-feedback display-block">
                                                        {formik.errors.submittedBy}
                                                    </div>
                                                ) : null}
                                            </ContentBlock>

                                            <ContentBlock cols={4}>
                                                <InputBlock
                                                    readOnly={!auth.isAdmin && isReadOnly}
                                                    label="Reports Results To"
                                                    value="katelyn@airenvironmental.net"
                                                    disabled
                                                />
                                            </ContentBlock>

                                            <ContentBlock cols={4}>
                                                <InputBlock
                                                    readOnly={!auth.isAdmin && isReadOnly}
                                                    label="Project Name"
                                                    {...formik.getFieldProps("projectName")}
                                                    disabled
                                                />
                                            </ContentBlock>

                                            <ContentBlock cols={4}>
                                                <InputBlock
                                                    readOnly={!auth.isAdmin && isReadOnly}
                                                    label="Project No"
                                                    {...formik.getFieldProps("projectNo")}
                                                    disabled
                                                />
                                            </ContentBlock>

                                        </Section>

                                        <Section removeContainer className="pt-10 pb-10 border-top">
                                            <ContentBlock>
                                                {/* LINE ITEMS TABLE */}
                                                <CustomBlock className="content-container--table-container">
                                                    <ContentHeader
                                                        title=" Line Items"
                                                        headerSize="md"
                                                        className="fw-700 dark-grey--clr pt-10"
                                                    />

                                                    <MUIDataTable
                                                        data={leadAirChainOfCustody.leadAirDataSheet.leadAirDataSheetLineItems}
                                                        columns={columns}
                                                        options={options}
                                                    />
                                                </CustomBlock>
                                            </ContentBlock>
                                        </Section>

                                        {/* FOOTER SECTION */}
                                        <Section removeContainer className="pt-10 border-top">
                                            <ContentBlock>
                                                <ContentHeader
                                                    readOnly={!auth.isAdmin && isReadOnly}
                                                    title="Additional Information"
                                                    headerSize="sm"
                                                    className="fw-700 pb-15"
                                                />
                                            </ContentBlock>
                                            <Section removeContainer className="pb-10">
                                                <ContentBlock cols={3}>
                                                    <InputBlock
                                                        readOnly={!auth.isAdmin && isReadOnly}
                                                        label="Sampler(s)"
                                                        {...formik.getFieldProps("samplers")}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={3}>
                                                    <div class="input-block-container">
                                                        <span class="static-label">Relenquished By</span>
                                                    </div>
                                                    <div class="input-block padded">
                                                        {formik.values.relenquishedBy ?
                                                            <img src={constants.API_URL + formik.values.relenquishedBy} />
                                                            :
                                                            <InputBlock
                                                                readOnly
                                                            />
                                                        }
                                                    </div>
                                                </ContentBlock>

                                                <ContentBlock cols={3}>
                                                    <InputBlock
                                                        disabled={!auth.isAdmin && isReadOnly}
                                                        label="Date"
                                                        type="date"
                                                        options={{
                                                            dateFormat: "m/d/Y"
                                                        }}
                                                        value={{ ...formik.getFieldProps("cocDate") }.value ? moment({ ...formik.getFieldProps("cocDate") }.value).format("L") : ''}
                                                        onChange={(e) => {
                                                            formik.setFieldValue("cocDate", moment(e[0]).format("L"))
                                                        }}
                                                    />
                                                </ContentBlock>
                                                <ContentBlock cols={3}>
                                                    <InputBlock
                                                        isRequired
                                                        type="date"
                                                        label="Time"
                                                        placeholder="hh:mm"
                                                        options={{
                                                            enableTime: true,
                                                            dateFormat: "H:i",
                                                            time_24hr: true,
                                                            noCalendar: true
                                                        }}
                                                        value={formik.getFieldProps("time").value}
                                                        onChange={date => {
                                                            formik.setFieldValue("cocTime", moment(date[0]).format("HH:mm"));
                                                        }}
                                                    />
                                                </ContentBlock>
                                            </Section>
                                        </Section>
                                        <Section removeContainer className="pt-10">
                                            <ContentBlock className="content-container--actions">
                                                {!auth.isAdmin ?
                                                    !isReadOnly &&
                                                    <>
                                                        <Button
                                                            text="Save Changes"
                                                            className="warning--bg"
                                                            onClick={() => {
                                                                saveCOC(formik.values, formik.setSubmitting, false)
                                                            }}
                                                        />
                                                        <Button
                                                            type="submit"
                                                            text="Submit Form"
                                                            className="success--bg"
                                                        />
                                                    </>
                                                    :
                                                    <>
                                                        <Button
                                                            text="Save Changes"
                                                            className="warning--bg"
                                                            onClick={() => {
                                                                saveCOC(formik.values, formik.setSubmitting, false)
                                                            }}
                                                        />
                                                        {
                                                            !isReadOnly &&
                                                            <Button
                                                                type="submit"
                                                                text="Submit Form"
                                                                className="success--bg"
                                                            />
                                                        }
                                                    </>
                                                }

                                            </ContentBlock>
                                        </Section>
                                    </CustomBlock>
                                </CustomBlock>
                            </ContentBlock>
                        </Section>
                    </FormBlock>
            }

            {/* CONFIRM DELETE MODAL */}
            <ModalBlock
                show={confirmDeleteModalVisible}
                contentHeader="Delete Line Item"
                onHide={() => setConfirmDeleteModalVisible(false)}
                closeAction
                centered
                contentDescription="Are you sure you want to delete this line item?"
                primaryModalActionOnClick={() => console.log("Deleting...")}
            />
        </>
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
})

export default connect(mapStateToProps, {
    ...alert.actions,
    ...confirmModal.actions
})(LeadAirCOCForm);